/* eslint-disable no-control-regex */
// Taken from: https://ghe.spotify.net/anchor/rss-service/blob/400d306ab82d57242e890783fa6bf5aaffb7099d/lib/stationFeed/stripIllegalUnicode.ts#L7

// https://www.ryadel.com/en/javascript-remove-xml-invalid-chars-characters-string-utf8-unicode-regex/
// As a matter of fact, according to the official XML 1.0 specifications, a valid XML file should only
// contain Unicode characters, excluding the surrogate blocks, FFFE, and FFFF. To keep it short, this
// means that the only valid characters should fall into one of the following groups:
// #x9, #xA, #xD, [#x20-#xD7FF], [#xE000-#xFFFD], [#x10000-#x10FFFF]

export const findIllegalControlCharsInXml = (s: string): boolean => {
  const regex =
    /([^\x09\x0A\x0D\x20-\uD7FF\uE000-\uFFFC\u{10000}-\u{10FFFF}])/gu; // eslint-disable-line no-control-regex
  return regex.test(s);
};
